module.exports = __webpack_public_path__ + "static/media/concerts.023a0b3a.jpg";